import React from "react";
import { Card, Tabs, Tab, NavDropdown } from "react-bootstrap";
import MyNutritionTabItem from "./myNutritionTabItem";
import "../home.scss";

export default function myNutrition({ recipesSubmitted, recipesFavourited, recentlyReviewed, history }) {
	return (
		<Card className="my-nutrition-card-container">
			<Card.Header>
				<div>My Recipes</div>
				<div>
					<NavDropdown
						alignRight
						title={
							<span className="nav-icon">
								<i className={`icon icon-more`} />
							</span>
						}
						className="custom-dropdown">
						<NavDropdown.Item href="/my-favourites">Manage My Favorites</NavDropdown.Item>
						<NavDropdown.Divider />
						<NavDropdown.Item href="/nutrition/recipes/add">Submit a Recipe</NavDropdown.Item>
						<NavDropdown.Divider />
						<NavDropdown.Item href="/nutrition/recipes">View Recipes</NavDropdown.Item>
					</NavDropdown>
				</div>
			</Card.Header>
			<Card.Body>
				<div className="tab-primary">
					<Tabs>
						<Tab eventKey="recipiesSubmitted" title="Submitted">
							<MyNutritionTabItem
								list={recipesSubmitted}
								onClick={({ id }) => history.push(`/nutrition/recipes/${id}/details`)}
								className="recipe-submitted-content-container"
							/>
						</Tab>
						<Tab eventKey="recipeFavourited" title="Favorited">
							<MyNutritionTabItem
								list={recipesFavourited}
								onClick={({ id }) => history.push(`/nutrition/recipes/${id}/details`)}
								className="recipe-favourired-content-container"
							/>
						</Tab>
						<Tab eventKey="latestReviews" title="Latest Reviews">
							<MyNutritionTabItem
								list={recentlyReviewed}
								type="comment"
								onClick={({ recipe_id }) => history.push(`/nutrition/recipes/${recipe_id}/details`)}
								className="latest-reviews-content-container border-bottom-list"
							/>
						</Tab>
					</Tabs>
				</div>
			</Card.Body>
		</Card>
	);
}
